"use client";

import { useLogin } from "@/context/useLoginProps";
import React from "react";

import DownloadApp from "../common/downloadApp";
import loginComponentMap from "./map";

const LoginForm: React.FC = () => {
  const { loginStep } = useLogin();
  const LoginStep = loginComponentMap[loginStep];

  return (
    <section className="mx-auto flex w-full flex-col pb-0 pt-8 md:!w-[60%] md:!pb-[62px] md:!pt-[62px]">
      <div className="px-4">{LoginStep && <LoginStep />}</div>
      <DownloadApp />
    </section>
  );
};

export default LoginForm;
